import Ax from './axios'


export const GetFavList = (data) => {  // getToken
    return Ax.post('Collection/List', {...data}).then(
      res => res.data
    )
}

export const UpdateFav = (data) => {  // getToken
    return Ax.post('Collection/SaveOrUpdate', {...data}).then(
      res => res.data
    )
}

export const UpdatePraise = (data) => {  // getToken
    return Ax.post('Praise/SaveOrUpdate', {...data}).then(
      res => res.data
    )
}



// WEBPACK FOOTER //
// ./src/api/favorites.js